import './helpers/publicPath';
import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import React from 'react';
// eslint-disable-next-line react/no-deprecated
import { hydrate } from 'react-dom';
import { createRoot } from 'react-dom/client';

import { Provider } from 'react-redux';
import { ConnectedRouter } from 'connected-react-router/immutable';
import * as Sentry from '@sentry/react';
import { Integrations } from '@sentry/tracing';

import { createBrowserHistory } from 'history';

/* eslint-disable */
// We need to load the config before anything else.
import {
  __DEBUG__,
  USE_SENTRY,
  APP_ENV,
  APP_ROOT_ELEMENT_ID,
  SENTRY_DSN,
  IS_CLIENT,
  initConfig,
} from './config/constants'
/* eslint-enable */

import configureStore from './store';
import * as serviceWorker from './serviceWorker';
import App from './containers/App';
import installSessionExpiredInterceptor from './helpers/sessionExpiredInterceptor';

import './styles/main.scss';

let sentryLoaded = false;

// Don't log env for production
if (__DEBUG__) {
  console.log(`Running environment ${APP_ENV}`);
  console.log(process.env);
}

const history = createBrowserHistory({
  basename: process.env.PUBLIC_URL,
});

const store = configureStore(history);

// Install global 401 interceptor to auto-logout on expired sessions.
installSessionExpiredInterceptor();

const loadTelemetry = () => {
  if (sentryLoaded) {
    return;
  }

  sentryLoaded = true;

  if (!__DEBUG__ && USE_SENTRY && SENTRY_DSN) {
    // TODO: replace DSN, go to https://sentry.uncinc.nl/organizations/sentry/projects
    // create a new project and copy the DSN
    Sentry.init({
      dsn: SENTRY_DSN,
      integrations: [new Integrations.BrowserTracing()],
      attachStacktrace: true,
      tracesSampleRate: 1.0,
    });
  }
};

const renderReactApp = (options) => {
  const render = () => {
    const container = document.getElementById(APP_ROOT_ELEMENT_ID);

    initConfig(options);
    // Load telemetry tools like sentry only after the config has been initialized
    loadTelemetry();

    const reactElement = (
      <Provider store={store}>
        <ConnectedRouter history={history}>
          <App />
        </ConnectedRouter>
      </Provider>
    );

    if (container && container.innerHTML !== '' && !__DEBUG__) {
      hydrate(reactElement, container);
    } else {
      const root = createRoot(container);
      root.render(reactElement);
    }
  };

  render();

  // Enable Webpack hot module replacement for components.
  if (module.hot) {
    module.hot.accept('./containers/App', () => {
      render();
    });
  }
};

if (window.reactFrontend) {
  window.reactFrontend.forEach((widgetOptions) => {
    renderReactApp(widgetOptions);
  });
}

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();
